export default function ScientificPattern({ variant = "hex", className = "" }) {
  if (variant === "grid") {
    return <div className={`absolute inset-0 bg-blueprint-grid pointer-events-none ${className}`} data-testid="scientific-pattern-grid" />;
  }
  if (variant === "dna") {
    return (
      <svg className={`absolute pointer-events-none ${className}`} viewBox="0 0 200 400" fill="none" data-testid="scientific-pattern-dna">
        <path d="M20 0 C80 50, 0 100, 60 150 C120 200, 20 250, 80 300 C140 350, 40 380, 100 400" stroke="#2563EB" strokeOpacity="0.08" strokeWidth="2" />
        <path d="M100 0 C40 50, 120 100, 60 150 C0 200, 100 250, 40 300 C-20 350, 80 380, 20 400" stroke="#1E3A8A" strokeOpacity="0.06" strokeWidth="2" />
      </svg>
    );
  }
  return <div className={`absolute inset-0 bg-hex-pattern pointer-events-none ${className}`} data-testid="scientific-pattern-hex" />;
}
